<template>
  <div>
    <div class="brand_table">
      <ButThrTable :DefaulTime='TimeDef2'></ButThrTable>
    </div>
  </div>
</template>
<script>
import ButThrTable from "@/components/ButThr/ButThr_NowTable";

export default {
  data() {
    return {
      showDate: false,
      TimeDef: "",
      TimeDef2: "",
      sumTime: "",
    };
  },
  components: {
    ButThrTable,
  },
  methods: {
    getUpdateTime() {
      this.$addr.post("weekly/getUpdateDate").then((res) => {
        var time = new Date(res.data.data[0].cyberwayMaxDate.time);
        var y = time.getFullYear();
        var m = (time.getMonth() + 1).toString().padStart(2, 0);
        var d = time.getDate().toString().padStart(2, 0);
        this.sumTime = `${y}-${m}-${d}`;
       
        this.TimeDef = res.data.data[0].hostMm;
        this.TimeDef2 = res.data.data[0].yyyymm;
        this.$emit("sendtime", [{sumTime:this.sumTime,TimeDef:this.TimeDef,TimeDef2:this.TimeDef2}]);
      });
    },
  },
  created() {
    this.getUpdateTime();
  },
};
</script>
<style scoped>
/deep/ .van-divider {
  font-family: "PingFangSC-Medium";
}
/deep/ .van-grid-item__text {
  color: rgb(200, 16, 46);
  font-size: 14px;
  word-wrap: break-word;
}
/deep/ .van-grid-item__content {
  background: #fff;
  border-radius: 20px;
}
.SelTop {
  position: relative;
  display: flex;
  padding: 0 16px;
  width: 100%;
  justify-content: space-between;
}
.SelTop .sel_left {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 300px;
  height: 21px;
  background: #ffffff;
  border: 1px solid #f1cbc9;
  box-shadow: 0 2px 5px 0 rgba(207, 111, 82, 0.3);
  border-radius: 42.5px;
}
.SelTop .sel_left p {
  padding-left: 14px;
  font-family: "PingFangSC-Medium";
  font-size: 12px;
  line-height: 21px;
  color: #d1534b;
}
.SelTop .sel_left b {
  display: inline-block;
  width: 8px;
  height: 11px;
  border-width: 6px;
  border-style: solid;
  border-color: transparent #d1534b transparent transparent;
  transform: scaleY(-1) rotate(180deg);
}
.SelTop .sel_right {
  position: relative;
  /* display: flex;
  align-items: center;
  justify-content: space-between; */
  width: 400px;
  height: 21px;
  background: rgba(152, 152, 152, 0.5);
  box-shadow: inset 0 0 5px 0 #9e9e9e;
  border-radius: 42.5px;
  margin-left: 10px;
}
.SelTop .sel_right p {
  float: left;
  font-family: "PingFangSC-Medium";
  font-size: 10px;
  line-height: 21px;
  color: #f9f9f9;
  padding-left: 13px;
}
.SelTop .sel_right b {
  float: right;
  margin-right: 5px;
  margin-top: 5px;
  text-align: center;
  line-height: 12px;
  font-size: 10px;
  background: #f9f9f9;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.brand_table {
  margin: 10px 0 40px;
}
.showDate {
  padding: 20px;
  font-family: "PingFangSC-Light";
  font-size: 10px;
  color: #191919;
  border: 1px solid black;
  z-index: 4;
  position: absolute;
  top: 30px;
  background: #fcfcfc;
  border-radius: 15px;
  min-height: 20px;
  width: 90%;
}
ul li {
  margin-bottom: 2px;
  font-size: 10px;
  color: #191919;
  width: 100%;
  height: 20px;
  white-space: nowrap; /* 强制不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px solid rgba(157, 157, 157, 0.4);
  line-height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/ButThr/ButThr_PosFull.vue